<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <router-link
        v-if="item.slink !== ''"
        :to="item.slink"
        :key="item.sname"
        :index="item.sid"
      >
        <el-menu-item :index="item.sid" :key="item.sname">
          <template>
            <img
              :src="item.c_turl"
              style="margin-left: 8%; width: 10%; margin-right: 2%"
            />
            <span>{{ item.sname }}</span>
          </template>
        </el-menu-item>
      </router-link>
      <el-submenu
        :index="item.sid"
        :key="item.sname"
        v-if="item.chlist.length > 0"
      >
        <template slot="title">
          <icon-svg v-if="item.icon" :icon-class="item.icon"></icon-svg>
          <img
            :src="item.c_turl"
            style="margin-left: 8%; width: 10%; margin-right: 2%"
          />
          <span>{{ item.sname }}</span>
        </template>
        <template v-for="child in item.chlist">
          <sidebar-item
            class="nest-menu"
            v-if="child.chlist && child.chlist.length > 0"
            :routes="[child]"
            :key="child.sname"
          >
          </sidebar-item>
          <router-link
            v-if="
              child.slink != null &&
                child.slink.indexOf('http') != 0 &&
                child.type != 'dirt' &&
                child.isShow != '1'
            "
            :to="child.slink"
            :key="child.sname"
          >
            <el-menu-item :index="'/' + item.sid + '/' + child.sid">
              <icon-svg v-if="child.icon" :icon-class="child.icon"></icon-svg>
              <img
                :src="child.c_turl"
                style="margin-left: 8%; width: 10%; margin-right: 2%"
              />
              <span>{{ child.sname }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
//菜单关闭
.el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotateZ(-90deg);
}
.el-submenu > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(-90deg);
  -ms-transform: rotate(-90deg);
  transform: rotateZ(-90deg);
}
//菜单展开
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(0deg);
  -ms-transform: rotate(0deg);
  transform: rotateZ(0deg);
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(0deg);
  -ms-transform: rotate(0deg);
  transform: rotateZ(0deg);
}

.el-submenu__icon-arrow {
  // position: absolute;
  // top: 50%;
  // left: 20px;
  // margin-top: -7px;
  // -webkit-transition: -webkit-transform .3s;
  // transition: -webkit-transform .3s;
  // transition: transform .3s;
  // transition: transform .3s,-webkit-transform .3s;
  font-size: 14px;
  font-weight: bold;
}

.el-submenu__icon-arrow {
  // position: absolute;
  // top: 50%;
  // left: 20px;
  // margin-top: -7px;
  // -webkit-transition: -webkit-transform .3s;
  // transition: -webkit-transform .3s;
  // transition: transform .3s;
  // transition: transform .3s,-webkit-transform .3s;
  font-size: 14px;
  font-weight: bold;
}
.el-submenu__title i {
  color: #0075b8;
}
.el-submenu__title i {
  color: #0075b8;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/SidebarItem.vue